import type {FormSelectFieldOption} from '@gl/lit/components/base/form_select_field/index.js';

export enum CampaignType {
  NEW = 'New',
  EXISTING = 'Existing',
}

export enum QualtricsListType {
  XM_DIRECTORY = 'XM Directory',
  MAILING_LIST = 'Mailing List',
}

// Treat this value as an empty option value for some select fields
export const EmptyOptionValue = '-1';

export enum SyncEndValues {
  YES = 'yes',
  NO = 'no',
}

export const CampaignTypeOptions: FormSelectFieldOption[] = [
  {label: CampaignType.NEW, value: CampaignType.NEW},
  {label: CampaignType.EXISTING, value: CampaignType.EXISTING},
];
export const PulsePointProducts: FormSelectFieldOption[] = [
  {label: 'LIFE', value: 'LIFE'},
];
export const QualtricsListTypes: FormSelectFieldOption[] = [
  /*
  * Commented out as Bifrost does not support XM Directory for now
  {
    label: QualtricsListType.XM_DIRECTORY,
    value: QualtricsListType.XM_DIRECTORY,
  },
  */
  {
    label: QualtricsListType.MAILING_LIST,
    value: QualtricsListType.MAILING_LIST,
  },
];
export const ViantSegmentIdTypes: FormSelectFieldOption[] = [
  {label: 'Userpool', value: 'Userpool'},
  {label: 'Taxonomy', value: 'Taxonomy'},
  {label: 'Third Party', value: 'Third Party'},
];
